import React, { Component } from 'react';
import { View, TouchableOpacity } from 'react-native';

import Text from '../textComponent';

import styles from './styles';
import Colors from '../../config/Colors';
import { ExpandMore } from '@mui/icons-material';

export default class ButtonFiltro extends Component {
    render() {
        const { filtroAtual, onPress, isOpen } = this.props;

        const label = () => {
            switch (filtroAtual[0]) {
                case 'todos':
                    return 'Todos';
                case 'disponivel':
                    return 'Disponíveis';
                case 'indisponivel':
                    return 'Indisponíveis';
                default:
                    break;
            }
        };

        return (
            <TouchableOpacity
                style={[
                    styles.button,
                    this.props.style,
                    isOpen && {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderBottomWidth: 1
                    }
                ]}
                onPress={onPress}
            >
                <View style={styles.buttonBox}>
                    <View style={styles.text}>
                        <Text style={styles.buttonText}>
                            {isOpen ? 'Selecione' : label()}
                        </Text>
                    </View>
                    <View style={styles.icon}>
                        <ExpandMore
                            sx={{
                                color: Colors.black,
                                fontSize: 32
                            }}
                        />
                    </View>
                </View>
            </TouchableOpacity>
        );
    }
}
